// extracted by mini-css-extract-plugin
export default {"toolbar":"ulz9Vs"};